
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "LLDOCM",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/LLDOCM.vue